module.exports = __webpack_public_path__ + "img/img37.1c5b64e7.png";